import BaseChart from './BaseChart';

/**
 * Rose chart implementation using VChart
 */
class RoseChart extends BaseChart {
  /**
   * Get chart specification for rose chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Resolve fields from data — auto-detect from data when defaults don't match
    const valueField = this._resolveField('valueField', 'value', ['score', 'amount', 'count', 'metric'])
      || this._resolveValueField();
    const categoryField = this._resolveField('categoryField', 'category', ['name', 'label', 'dimension', 'segment'])
      || this._resolveNameField();
    const seriesField = this.options.seriesField;
    
    return {
      type: 'rose',
      data,
      valueField,
      categoryField,
      seriesField,
      
      // Rose specific styling
      rose: {
        style: {
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.roseStyle
        },
        state: {
          hover: {
            offset: 10,
            stroke: '#fff',
            lineWidth: 2
          },
          ...this.options.roseState
        }
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default RoseChart; 